import { render, staticRenderFns } from "./wishlist-icon.vue?vue&type=template&id=ec9f427e"
import script from "./wishlist-icon.vue?vue&type=script&lang=js"
export * from "./wishlist-icon.vue?vue&type=script&lang=js"
import style0 from "./wishlist-icon.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports